import { EditSettingsAction } from '@leverege/molten/data-viewers'
import { ItemEditor } from '@leverege/ui-attributes'

export default new EditSettingsAction( {
  id : 'ps.dataViewers.aisles.AisleCardDataViewer',
  matches : { use : 'actionBar', client : 'AisleCardDataViewer' },
  editor : ItemEditor,
  title : 'Aisle Card Editor',
  versionType : 'aislesCard',
  editorProps : ( opts ) => {
    const { delegate, objectType, blueprint, relationship } = opts.context?.clientProps || {}
    return { delegate, objectType, blueprint, relationship }
  }
} )
